"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.date.to-iso-string");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

function s(s) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {},
        e = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (e = e.concat(Object.getOwnPropertySymbols(o).filter(function (t) {
      return Object.getOwnPropertyDescriptor(o, t).enumerable;
    }))), e.forEach(function (t) {
      var e, n, i;
      i = o[n = t], n in (e = s) ? Object.defineProperty(e, n, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = i;
    });
  }

  return s;
}

var o = {
  year: "numeric",
  month: "long",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
},
    i = function i(t) {
  return new Array(t).fill();
},
    r = function r(t) {
  var e = new Date(),
      n = new Intl.DateTimeFormat("en-US", s({}, o, {
    timeZone: "UTC"
  })).format(e),
      i = new Intl.DateTimeFormat("en-US", s({}, o, {
    timeZone: t
  })).format(e);
  return new Date(i).getTime() - new Date(n).getTime();
},
    d = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})+/;

module.exports = {
  timezone: "UTC",
  timezoneDiff: 0,
  setTimezone: function setTimezone(t) {
    this.timezoneDiff = r(t), this.timezone = t;
  },
  decompose: function decompose(t) {
    var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : this.timezone,
        n = e === this.timezone ? this.timezoneDiff : r(e);
    return new Date(t + n).toISOString().match(d).slice(1);
  },
  addOneMonth: function addOneMonth(i, t) {
    var s = this,
        o = this.getDay(i),
        r = t ? -1 : 1,
        e = [28, 29, 30, 31].reduce(function (t, e) {
      var n = Math.abs(parseInt(s.getDay(s.addDays(i, e * r)), 10) - o);
      return null === t.diff || n < t.diff ? {
        value: e,
        diff: n
      } : t;
    }, {
      value: null,
      diff: null
    });
    return this.addDays(i, e.value * r);
  },
  getYear: function getYear(t, e) {
    return this.decompose(t, e)[0];
  },
  getMonth: function getMonth(t, e) {
    return this.decompose(t, e)[1];
  },
  getWeekDay: function getWeekDay(t) {
    return (Math.floor((t + this.timezoneDiff) / 864e5) % 7 + 3) % 7;
  },
  getDay: function getDay(t, e) {
    return this.decompose(t, e)[2];
  },
  getHours: function getHours(t, e) {
    return this.decompose(t, e)[3];
  },
  getMinutes: function getMinutes(t, e) {
    return this.decompose(t, e)[4];
  },
  getSeconds: function getSeconds(t, e) {
    return this.decompose(t, e)[5];
  },
  getMilliseconds: function getMilliseconds(t, e) {
    return this.decompose(t, e)[6];
  },
  addMonths: function addMonths(t, e) {
    var n = this;
    return i(Math.abs(e)).reduce(function (t) {
      return n.addOneMonth(t, e < 0);
    }, t);
  },
  addYears: function addYears(t, e) {
    var n = this;
    return i(Math.abs(e)).reduce(function (t) {
      return n.addMonths(t, 0 < e ? 12 : -12);
    }, t);
  },
  addDays: function addDays(t, e) {
    return t + 864e5 * e;
  },
  addHours: function addHours(t, e) {
    return t + 36e5 * e;
  },
  addMinutes: function addMinutes(t, e) {
    return t + 6e4 * e;
  },
  addSeconds: function addSeconds(t, e) {
    return t + 1e3 * e;
  },
  addMilliseconds: function addMilliseconds(t, e) {
    return t + e;
  },
  add: function add(t, e) {
    var n = e.years,
        i = void 0 === n ? 0 : n,
        s = e.months,
        o = void 0 === s ? 0 : s,
        r = e.days,
        d = void 0 === r ? 0 : r,
        u = e.hours,
        a = void 0 === u ? 0 : u,
        c = e.minutes,
        h = void 0 === c ? 0 : c,
        f = e.seconds,
        l = void 0 === f ? 0 : f,
        m = e.milliseconds;
    return this.addYears(this.addMonths(this.addDays(this.addHours(this.addMinutes(this.addSeconds(this.addMilliseconds(t, void 0 === m ? 0 : m), l), h), a), d), o), i);
  },
  setYear: function setYear(t, e) {
    return this.addYears(t, e - this.getYear(t));
  },
  setMonth: function setMonth(t, e) {
    return this.addMonths(t, e - this.getMonth(t));
  },
  setWeekDay: function setWeekDay(t, e) {
    return this.addDays(t, e - this.getWeekDay(t));
  },
  setDay: function setDay(t, e) {
    return this.addDays(t, e - this.getDay(t));
  },
  setHours: function setHours(t, e) {
    return this.addHours(t, e - this.getHours(t));
  },
  setMinutes: function setMinutes(t, e) {
    return this.addMinutes(t, e - this.getMinutes(t));
  },
  setSeconds: function setSeconds(t, e) {
    return this.addSeconds(t, e - this.getSeconds(t));
  },
  setMilliseconds: function setMilliseconds(t, e) {
    return this.addMilliseconds(t, e - this.getMilliseconds(t));
  },
  set: function set(t, e) {
    var n = e.month,
        i = e.day,
        s = e.hours,
        o = e.minutes,
        r = e.seconds,
        d = e.milliseconds,
        u = e.year || this.getYear(t),
        a = n || this.getMonth(t),
        c = i || this.getDay(t),
        h = s || this.getHours(t),
        f = o || this.getMinutes(t),
        l = r || this.getSeconds(t),
        m = d || this.getMilliseconds(t);
    return this.setYear(this.setMonth(this.setDay(this.setHours(this.setMinutes(this.setSeconds(this.setMilliseconds(t, m), l), f), h), c), a), u);
  }
};